<template>
  <main>
    <NewNavBar />
    <div class="content">
      <slot> </slot>
    </div>
  </main>
</template>

<script>
import NavBar from "./Modules/NavBar.vue";
import Main from "./Modules/Main.vue";
import NewNavBar from "./Modules/NewNavBar.vue";
export default {
  components: { Main, NavBar, NewNavBar },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}

body {
  overflow-x: hidden;
  background: var(--grayBody);
}

.sc  {
  overflow-y: hidden;
}

a {
  text-decoration: none;
}
.content {
  width: 100%;
  height: 100%;
  margin-left: 0;
  padding: 2rem;
  transition: 0.5s;
}

@media (max-width: 425px) {
  .content {
    padding: 0;
  }
}
</style>
